// extracted by mini-css-extract-plugin
export default {"component":"component__oRPbu","title":"title__Pqg_c","ctaButton":"ctaButton__kyWTZ","arrow":"arrow__FCh_h","link":"link__e3lt0","listItem":"listItem__MMj76"};